<template>
    <a-list-item class="tower-item">
        <a-list-item-meta>
            <img slot="avatar" :src="cover" />
            <a slot="title" :href="link"><h4>{{ title }}</h4></a>
            <p slot="description" class="author">
                {{ author }}<span v-if="author2">/{{ author2 }}</span>
            </p>
        </a-list-item-meta>
    </a-list-item>
</template>

<script>
export default {
    props: {
        name: String,
        title: String,
        author: String,
        author2: String,
        link: String,
        image: String,
    },
    computed: {
        cover() {
            if (this.image) return this.image;
            return this.link + (this.link.slice(-1) == "/" ? "" : "/") + "project/images/bg.jpg";
        },
    }
}
</script>

<style scoped>
.ant-list-item-meta-avatar {
    margin-right: 8px;
}
img {
    height: 42px;
    width: 55px;
    object-fit: cover;
}
h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    width: 165px;
}
.author {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: 13px;
    width: 165px;
}
.tower-item {
    padding: 8px;
}
</style>